import { type AssetCategory, AssetCategoryValues, AssetTypes, LeadStatus } from '@inpart-io/padme-iap';

import { LeadStatusSet } from '@/components/lead-profile/components/lead-status/constants/lead.status.constants';

import { LeadStatusColorEnum } from './color.options';
import { ICONS_NAME } from './ui/icons.constants';

export const LeadStatusIcon = new Map<LeadStatus | LeadStatusSet, string>([
    [LeadStatusSet.CLOSED, ICONS_NAME.CHECK_CIRCLE_SOLID],
    [LeadStatus.DISQUALIFIED, ICONS_NAME.TIMES_CIRCLE_SOLID],
    [LeadStatus.ON_HOLD, ICONS_NAME.PAUSE_CIRCLE_SOLID],
    [LeadStatusSet.ACTIVE, ICONS_NAME.PLAY_CIRCLE_SOLID]
]);

export const LeadStatusColor = new Map<LeadStatus | LeadStatusSet, string>([
    [LeadStatus.DRAFT, LeadStatusColorEnum.DRAFT],
    [LeadStatus.TRIAGE, LeadStatusColorEnum.TRIAGE],
    [LeadStatusSet.ACTIVE, LeadStatusColorEnum.ACTIVE],
    [LeadStatusSet.CLOSED, LeadStatusColorEnum.CLOSED],
    [LeadStatus.QUALIFIED, LeadStatusColorEnum.QUALIFIED],
    [LeadStatus.CLOSED, LeadStatusColorEnum.CLOSED],
    [LeadStatus.DISQUALIFIED, LeadStatusColorEnum.DISQUALIFIED],
    [LeadStatus.ON_HOLD, LeadStatusColorEnum.ON_HOLD]
]);

export const LeadStatusColorClass = new Map<LeadStatus | LeadStatusSet, string>([
    [LeadStatusSet.ACTIVE, 'active'],
    [LeadStatusSet.CLOSED, 'closed'],
    [LeadStatus.DISQUALIFIED, 'disqualified'],
    [LeadStatus.ON_HOLD, 'on-hold']
]);

export const AssetTypeIcon = new Map<AssetTypes, string>([
    [AssetTypes.PHARMA_ASSET, ICONS_NAME.PHARMA_ASSET_OUTLINE],
    [AssetTypes.TECHNO_SOLUTION, ICONS_NAME.TECHNO_SOLUTION_OUTLINE],
    [AssetTypes.COMPANY, ICONS_NAME.COMPANY_OUTLINE],
    [AssetTypes.CONSUMER_HEALTH, ICONS_NAME.CONSUMER_HEALTH_OUTLINE],
    [AssetTypes.OTHERS_ASSET, ICONS_NAME.QUESTION_MARK_CIRCLE_OUTLINE]
]);

export const AssetCategoryIcon = new Map<AssetCategory, string>([
    [AssetCategoryValues.PHARMA_ASSET, ICONS_NAME.PHARMA_ASSET_OUTLINE],
    [AssetCategoryValues.TECHNO_SOLUTION, ICONS_NAME.TECHNO_SOLUTION_OUTLINE],
    [AssetCategoryValues.COMPANY, ICONS_NAME.COMPANY_OUTLINE],
    [AssetCategoryValues.CONSUMER_HEALTH, ICONS_NAME.CONSUMER_HEALTH_OUTLINE]
]);

export enum DatePeriods {
    ONE_MONTH = 'ONE_MONTH',
    THREE_MONTHS = 'THREE_MONTHS',
    SIX_MONTHS = 'SIX_MONTHS',
    ONE_YEAR = 'ONE_YEAR',
    CUSTOM = 'CUSTOM'
}

export const MOBILE_BREAKPOINT = 600;
